<template>
  <div class="tw-relative tw-flex tw-flex-col tw-justify-center">
    <label v-if="showLabel" :for="label" class="tw-text-sm">{{ label }}</label>
    <input
      :type="type"
      ref="numberInput"
      class="tw-text-xl tw-rounded tw-py-4 tw-px-5 focus:tw-border-primary"
      :class="{
        'tw-border-error': showError === true,
      }"
      v-model="numberData"
      @input="setInput"
      @keypress="isNumber($event)"
      @blur="validate"
      @keydown.enter="blurInput"
      :placeholder="placeHolder"
      :id="id"
      :name="name"
      :disabled="disabled"
      required
    />
    <p class="tw-absolute tw--top-4 tw-right-px tw-text-error tw-text-xs">
      {{ errorMsg }}
    </p>
  </div>
</template>

<script>
import useValidate from "@vuelidate/core";
import { required, minValue, maxValue } from "@vuelidate/validators";
import { isNumber, convertToLocale } from "@/utils/helpers.js";

export default {
  name: "NumberInput",

  emits: ["set", "valid", "validate"],

  props: {
    placeHolder: { type: String, default: () => "", required: true },
    label: { type: String, default: () => "" },
    id: { type: String, default: () => "" },
    name: { type: String, default: () => "" },
    amount: { type: String, default: () => "" },
    minNumber: { type: Number, default: () => 0 },
    maxNumber: { type: Number, default: () => 0 },
    fieldType: { type: String, default: () => "" },
    type: { type: String, default: () => "" },
    checkValidity: { type: Boolean, default: () => false },
    showLabel: { type: Boolean, default: () => false },
    disabled: { type: Boolean, default: () => false },
  },

  data() {
    return {
      v$: useValidate(),
      numberData: "",
      intNumberData: "",
      errorMsg: "",
      showError: false,
    };
  },

  computed: {
    formatNumberData() {
      if (this.numberData === "NaN") {
        this.showError = false;
        this.errorMsg = "";
        this.numberData = "";
        this.intNumberData = "";
      }
      return this.convertToLocale(Number(this.intNumberData));
    },
  },

  validations() {
    return {
      amount: {
        required,
        minValue: this.minNumber !== 0 ? minValue(Number(this.minNumber)) : "",
        maxValue: this.maxNumber !== 0 ? maxValue(Number(this.maxNumber)) : "",
      },
    };
  },

  methods: {
    isNumber,
    convertToLocale,

    validate() {
      this.v$.$reset();
      switch (this.fieldType) {
        case "amount":
          this.v$.amount.$touch();
          break;
        case "dollarAmount":
          this.v$.amount.$touch();
          break;
        case "nairaAmount":
          this.v$.amount.$touch();
          break;
        case "tokenAmount":
          this.v$.amount.$touch();
          break;

        default:
          break;
      }
      if (this.v$.$errors.length === 0) {
        this.$emit("valid", true);
        return (this.showError = false), (this.errorMsg = "");
      }
      this.$emit("valid", false);
      this.errorMsg = this.v$.$errors[0].$message;
      this.showError = true;
    },

    setInput() {
      this.showError = false;
      this.errorMsg = "";
      this.$emit("set", this.intNumberData);
    },

    blurInput() {
      this.validate();
      setTimeout(() => {
        this.$refs.numberInput?.blur();
      }, 500);
    },
  },

  watch: {
    formatNumberData(val) {
      this.numberData = val;
    },

    numberData(val) {
      this.intNumberData = val.split(",").join("");
    },

    amount(val) {
      this.numberData = this.convertToLocale(Number(val));
    },

    checkValidity(val) {
      if (val) {
        this.validate();
        this.$emit("validate");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
